import type { TutorialStep } from './types'
import TUTORIAL_VIDEO from '@public/assets/tutorial/reassign-activities-tutorial-video.mp4'

export const TUTORIAL_DIALOG_TITLE = 'Tutorial: How to Use Suggested Entries'

const VIDEO_BASE_URL =
  'https://attitturesource.blob.core.windows.net/mira/video'

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: 'create-suggested-entry',
    title: 'Create a time entry from a Suggested Entry',
    videoUrl: `${VIDEO_BASE_URL}/tutorial-timeline-1.mp4`,
  },
  {
    id: 'remove-activities',
    title: 'Remove activities from a Suggested Entry',
    videoUrl: `${VIDEO_BASE_URL}/tutorial-timeline-2.mp4`,
  },
  {
    id: 'move-activities',
    title: 'Move activities between Suggested Entries',
    videoUrl: `${VIDEO_BASE_URL}/tutorial-timeline-3.mp4`,
  },
  {
    id: 'combine-groups',
    title: 'Create a time entry using activities from multiple groups',
    videoUrl: `${VIDEO_BASE_URL}/tutorial-timeline-4.mp4`,
  },
  {
    id: 'drag-to-time-entry',
    title: 'Create a time entry by dragging activities to the Time Entry panel',
    videoUrl: `${VIDEO_BASE_URL}/tutorial-timeline-5.mp4`,
  },
  {
    id: 'merge-activities',
    title: 'Merge activities into an existing time entry',
    videoUrl: `${VIDEO_BASE_URL}/tutorial-timeline-6.mp4`,
  },
  {
    id: 'reassign-activities',
    title: 'Reassign activities to separate time entries',
    contentTitle:
      'Need to make changes after accepting a group of activities into a time entry?',
    videoUrl: TUTORIAL_VIDEO,
  },
]
